import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { Button } from '@/components/ui/button'
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza'
import MeterStatusForm from '@/components/forms/meter-status-form'
import { Header } from '@/components/header'
import { Icons } from '@/components/icons'

export const Route = createFileRoute(
  '/_home/meter-connection-settings/meter-status/add',
)({
  component: AddMeterStatusPage,
})

export function AddMeterStatusPage() {
  const [showAddMeterStatusModal, setShowAddMeterStatusModal] =
    React.useState<boolean>(false)
  return (
    <>
      <main>
        <Button
          onClick={() => setShowAddMeterStatusModal(!showAddMeterStatusModal)}
        >
          <Icons.add />
          Add Meter Status
        </Button>
        <Credenza
          open={showAddMeterStatusModal}
          onOpenChange={setShowAddMeterStatusModal}
        >
          <CredenzaContent className="flex w-full max-w-[850px] justify-center">
            <CredenzaBody className="mx-auto w-full max-w-6xl px-4">
              <Header
                subroutes={[
                  {
                    route: '/meter-connection-settings/meter-status',
                    label: 'Meter Status',
                  },
                ]}
              >
                Add Meter Status
              </Header>
              <MeterStatusForm
                onClose={() => setShowAddMeterStatusModal(false)}
              />
            </CredenzaBody>
          </CredenzaContent>
        </Credenza>
      </main>
    </>
  )
}
